<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'
const moment = require('moment')

export default {
  name: 'UserClasses',
  components: {
    Grid
  },
  // mounted () {
  //   this.fetchInstructorClasses(this.$store.state.users.userForm.USER_ID)
  // },
  data () {
    return {
      moment: moment,
      module: this.$route.meta.module,
      columnOptions: [
        // { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'SESSION_START_DATE', name: 'SESSION_START_DATE', label: 'Class Start Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'SESSION_END_DATE', name: 'SESSION_END_DATE', label: 'Class End Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'COURSE_NAME', name: 'COURSE_NAME', label: 'Course Name', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: false, filterable: false, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapState('users', {
      classes: state => state.instructorClassList,
      selectedUserId: state => state.selectedUser.USER_ID,
      userClassesLoading: s => s.userClassesLoading
    }),
    ...mapGetters('users', [
    ])
  },
  methods: {
    ...mapActions('users', [
      'fetchInstructorClasses'
    ]),
    ...mapActions('classes', [
      'one'
    ]),
    ...mapMutations('users', [
    ]),
    selectClass(e){
      let vm = this
      vm.one({id: e.CLASS_ID, mode: 'edit', vm})
    }
  }
}
</script>

<template>
  <div class="fit">
    <Grid
      :module="module"
      :data="classes"
      :columns="columnOptions"
      :onLaunch="selectClass"
      :onRequest="fetchInstructorClasses"
      :loading="userClassesLoading"
    />
  </div>
</template>

<style>
</style>
